export default __webpack_public_path__ + "static/media/ambasadorp1big_thumb.f7d4964d.jpg";